import { render } from "./ComponentRender.vue?vue&type=template&id=4a2d5f16"
import script from "./ComponentRender.vue?vue&type=script&lang=js"
export * from "./ComponentRender.vue?vue&type=script&lang=js"

import "./ComponentRender.vue?vue&type=style&index=0&id=4a2d5f16&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\au-csmv-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__